var _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5345_4250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 7,
    rx: 0.498,
    transform: "matrix(-1 0 0 1 21.299 .5)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 7,
    rx: 0.498,
    transform: "matrix(-1 0 0 1 21.299 .5)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_5345_4250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 7,
    rx: 0.498,
    transform: "matrix(-1 0 0 1 21.299 8.5)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 7,
    rx: 0.498,
    transform: "matrix(-1 0 0 1 21.299 8.5)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_5345_4250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 7,
    rx: 0.498,
    transform: "matrix(-1 0 0 1 10.299 .5)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 7,
    rx: 0.498,
    transform: "matrix(-1 0 0 1 10.299 .5)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4_5345_4250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 7,
    rx: 0.498,
    transform: "matrix(-1 0 0 1 10.299 8.5)"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 7,
    rx: 0.498,
    transform: "matrix(-1 0 0 1 10.299 8.5)"
  })));
}
SvgGrid.displayName = 'Grid';
export default SvgGrid;